import actions from 'actions';

/**
 * Initial state.
 * @type {Object}
 */
const initialState = {
    placesOptions: [],
    suggestedAddresses: [],
};

/**
 * address's reducer.
 * @param {String} state  Existing address's state
 * @param {Object} action Action dispatched
 * @return {Object} New state
 */
export default (state = initialState, action) => {
    switch (action.type) {
        case actions.RECEIVED_GET_CITIES_FROM_ZIP:
            return {
                ...state,
                placesOptions: action.places.map((place) => ({
                    value: place.name_short,
                    label: place.name_short,
                    geotypeLabel: place.geotype_label,
                    id: place.id,
                })),
            };
        case actions.UPDATE_ADDRESS_MAP_COORDINATES:
            return {
                ...state,
                mapCoordinates: action.mapCoordinates,
                zoom: action.zoom,
            };
        case actions.UPDATE_SELECTED_ADDRESS:
            return {
                ...state,
                selectedAddress: {
                    addressName: action.addressName,
                    cityName: action.cityName,
                    zip: action.zip,
                },
            };
        case actions.UPDATE_SELECTED_COORDINATES:
            return {
                ...state,
                selectedAddress: {
                    ...state.selectedAddress,
                    coordinates: action.coordinates,
                },
            };
        case actions.UPDATE_SUGGESTED_ADDRESSES:
            return {
                ...state,
                suggestedAddresses: action.addresses,
            };
        default:
            return state;
    }
};
